import { render, staticRenderFns } from "./DocumentosMovimientos.vue?vue&type=template&id=be844fc2&"
import script from "./DocumentosMovimientos.vue?vue&type=script&lang=js&"
export * from "./DocumentosMovimientos.vue?vue&type=script&lang=js&"
import style0 from "./DocumentosMovimientos.vue?vue&type=style&index=0&id=be844fc2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports